import { ViewModel,View } from "binder"
import { IStaticValueProvider } from "../IStaticValueProvider";
import  { ListEditorView } from "./listEditor-view"

export class ListEditorViewModel extends ViewModel implements IStaticValueProvider{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new ListEditorView();
    }
    public getTypeId(): string {
        return "VM-B560A4F0-00A5-4572-B072-3157FD3EBFC4"
    }

    setValue(v: string) {
    }
    getValue(): string {
        return null;
    }

    requestConfirm() {
    }

}
